import { BasketItemRenewal } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedRenewalConfirmation } from './checkout-completed-renewal-confirmation.interface';

export interface CheckoutCompletedRenewal {
  item: BasketItemRenewal;
  confirmation: CheckoutCompletedRenewalConfirmation;
}
